@if (source.show) {
  <mat-card-content>
    <h6 class="hierarchy-label">{{ source.sourceType }}</h6>
    <section class="mat-card-line">
      <span>
        <mat-radio-group [(ngModel)]="selectedSource">
          @for (pp of source.list; track pp.id; let i = $index) {
            <mat-radio-button
              [value]="pp.id"
              [checked]="pp.checked"
              (change)="onParentChange($event, source.sourceType, pp.name)"
              >
              {{ pp.name }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </span>
    </section>
  </mat-card-content>
}
